import styles from "./EnquiryAutomation.module.css";
import SearchBar from "../../components/SearchBar/SearchBar";
// import Dropdown from "../../components/Dropdown/Dropdown";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import Action from "../../components/Action/Action";
import { RiFileTextLine } from "react-icons/ri";
import CopyRight from "../../components/CopyRight/CopyRight";
import IconAndName from "../../components/IconAndName/IconAndName";
import { IoAddCircleOutline } from "react-icons/io5";

const data = [
  {
    _id: "1",
    rule: "Rule 1",
    condition: "-",
    status: "Active",
    actions: ["Edit", "Delete"],
  },
  {
    _id: "2",
    rule: "Rule 2",
    condition: "-",
    status: "Active",
    actions: ["Edit", "Delete"],
  },
  {
    _id: "3",
    rule: "Rule 3",
    condition: "-",
    status: "Active",
    actions: ["Edit", "Delete"],
  },
  {
    _id: "4",
    rule: "Rule 4",
    condition: "-",
    status: "Active",
    actions: ["Edit", "Delete"],
  },
];

function EnquiryAutomation() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const  handleautomation= () => {
    dispatch(openModal("createAutomation"));
  };
  const getColumnData = (data) => {
    return data.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              setSelectedIds((prev) =>
                checked
                  ? [...prev, item._id]
                  : prev.filter((id) => id !== item._id)
              );
            }}
          />
        ),
        rule: item.rule, // ✅ plain text
        condition: item.condition,
        status: (
          <div className={styles.status}>
            <span className={styles.greenDot}></span>
            {item.status}
          </div>
        ),
        action: (
          <Action
            options={item.actions}
            onSelect={(opt) => console.log(`Selected ${opt} for ${item.rule}`)}
          />
        ),
      };
    });
  };
  

  const displayData = getColumnData(data);

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            setSelectedIds(checked ? data.map((d) => d._id) : []);
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Title", accessor: "rule" },
    { title: "Condition", accessor: "condition" },
    { title: "Status", accessor: "status" },
    { title: "Action", accessor: "action" },
  ];
  

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <div className={styles.createAutomation}>
          <IconAndName
            icon={<IoAddCircleOutline />}
            title="Create Automation"
            bgColor="Primary_Color"
            onClick={handleautomation}
          />
        </div>

        <div className={styles.totalstudentcard}>
          <div className={styles.studentsection}>
            <div className={styles.search}>
              <SearchBar
                placeholder="Search rule"
                onChange={(e) => console.log(e.target.value)}
              />
            </div>
            
          </div>

          <div className={styles.dynamicdata}>
            <Dynamic
              headings={headingsData}
              columnData={displayData.slice(
                (currentPage - 1) * itemsPerPage,
                currentPage * itemsPerPage
              )}
            />
          </div>
          <div className={styles.paginationTable}>
            <PaginationTable
              data={displayData}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              setCurrentPage={setCurrentPage}
              setItemsPerPage={setItemsPerPage}
            />
          </div>
        </div>
      </div>
      <CopyRight />
    </div>
  );
}

export default EnquiryAutomation;
